export default __webpack_public_path__ + "static/media/expose2.5c6b190e.png";